import { api as wiredApi, tokenStore as wiredTokenStore } from './index';

/**
 * "Continue with Google" on InGo's API (InGo ADR 0023; ingo-e0, 2 Oct 2026),
 * for a client (`customer`) or a rider (`rider`). Off until the office turns
 * it on in Settings, Sign-in methods, with the web client id; both are public,
 * so the app asks before showing the button, and no build carries a copy of
 * the id (ADR 0023 §4).
 *
 * Built from its collaborators so a test can hand it fakes; `googleSignIn` is
 * the wired copy.
 */
export function createGoogleSignIn({ api, tokenStore }) {
  return {
    /** `{ clientId }` while Settings offers Google with a web client id; null otherwise. */
    async config() {
      const { data } = await api.get('/public/settings');
      const auth = data?.settings?.auth ?? {};
      const clientId = typeof auth.google_web_client_id === 'string' ? auth.google_web_client_id.trim() : '';

      return auth.google_enabled === true && clientId !== '' ? { clientId } : null;
    },

    /**
     * `POST {realm}/auth/google` with Google's ID token. Signed in: the token
     * stored, the account answered. A rider Google vouched for with no
     * account yet: `sign_up`, with what Google said, for the registration
     * form (a rider is never made from Google alone).
     */
    async signIn(realm, idToken) {
      const { data } = await api.post(`/${realm}/auth/google`, { id_token: idToken });

      if (data?.status === 'sign_up') {
        return { status: 'sign_up', profile: { firstName: data.first_name ?? '', lastName: data.last_name ?? '', email: data.email ?? '' } };
      }

      await tokenStore.write(data.token);

      return { status: 'signed_in', account: data.account, mustChangePassword: Boolean(data.must_change_password) };
    },

    /** `POST {realm}/auth/google/link`, signed in: Google for the account's own address, after its password once. */
    async link(realm, idToken) {
      await api.post(`/${realm}/auth/google/link`, { id_token: idToken });
    },
  };
}

export const googleSignIn = createGoogleSignIn({ api: wiredApi, tokenStore: wiredTokenStore });
